"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactApollo = require("react-apollo");
var _reactRedux = require("react-redux");
var _commonLoader = require("@mmc/common-loader");
var _siteSearch = _interopRequireDefault(require("./site-search.css"));
var _siteSearch2 = require("./site-search.query");
var _commonRichText = require("@mmc/common-rich-text");
var _CommonLoader;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var SiteSearch = function SiteSearch(props) {
  var data = props.data,
    theme = props.theme,
    market = props.market,
    language = props.language,
    path = props.path,
    compProps = props.compProps,
    router = props.router;
  var label = data.label,
    placeholder = data.placeholder,
    viewMoreLabel = data.viewMoreLabel,
    viewmorepagenation = data.viewmorepagenation,
    emptyResultsMessage = data.emptyResultsMessage,
    searchInputWarningMessage = data.searchInputWarningMessage;
  var searchRootPath = compProps.searchRootPath;
  var _useState = (0, _react.useState)(),
    searchTerm = _useState[0],
    setSearchTerm = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    isSearchTermValid = _useState2[0],
    setIsSearchTermValid = _useState2[1];
  var _useState3 = (0, _react.useState)(viewmorepagenation),
    resultCount = _useState3[0],
    setResultCount = _useState3[1];
  var inputRef = (0, _react.useRef)(null);

  // on initial function load
  (0, _react.useEffect)(function () {
    var urlParams = new URLSearchParams(window.location.search);
    var q = urlParams.get('q');
    if (q) {
      setSearchTerm(q);
    }
    inputRef.current.focus();
  }, []);
  (0, _react.useEffect)(function () {
    var isValid = validateSearchTerm(searchTerm);
    setIsSearchTermValid(isValid);
  }, [searchTerm]);
  var updateSearchTerm = function updateSearchTerm(q) {
    setSearchTerm(q);
    updateURLBar(q);
  };
  var onKeyDown = function onKeyDown(e) {
    var isEnter = e.keyCode === 13;
    if (isEnter) {
      updateSearchTerm(e.target.value);
    }
  };
  var validateSearchTerm = function validateSearchTerm(term) {
    var MIN_3_CHAR_PATTERN = /^.{3,}$/;
    return MIN_3_CHAR_PATTERN.test(term);
  };
  var updateURLBar = function updateURLBar(q) {
    var url = new URL("" + window.location.href);
    url.searchParams.set('q', q);
    window.history.replaceState({
      urlPath: url.href
    }, '', url.href);
  };
  var queryParams = {
    market: market,
    lang: language,
    path: path,
    searchTerm: searchTerm,
    searchRoot: searchRootPath
  };
  var renderSearchResults = function renderSearchResults() {
    return isSearchTermValid && /*#__PURE__*/_react["default"].createElement(_reactApollo.Query, {
      query: _siteSearch2.SEARCH_QUERY,
      variables: queryParams,
      onCompleted: function onCompleted() {
        /* RESET RESULT COUNT TO INITIAL VALUE */
        setResultCount(viewmorepagenation);
      }
    }, function (_ref) {
      var queryData = _ref.data,
        loading = _ref.loading;
      if (loading) {
        return _CommonLoader || (_CommonLoader = /*#__PURE__*/_react["default"].createElement(_commonLoader.CommonLoader, null));
      }
      if (queryData && queryData.getSearchFilter) {
        var results = queryData.getSearchFilter.results;
        var response = results && results.length ? renderResults(results) : /*#__PURE__*/_react["default"].createElement("div", {
          className: _siteSearch["default"].searchErrorMsg
        }, emptyResultsMessage);
        return response;
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    });
  };
  var renderResults = function renderResults(results) {
    var hasViewMoreBtn = results.length > resultCount;
    var partial = results.slice(0, resultCount);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("ul", {
      className: _siteSearch["default"].resultsList
    }, !!partial.length && partial.map(function (result, index) {
      return /*#__PURE__*/_react["default"].createElement("li", {
        key: "result-" + index
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: result.link
      }, /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        html: result.title,
        tagName: "h4"
      }), /*#__PURE__*/_react["default"].createElement(_commonRichText.CommonRichText, {
        theme: theme,
        html: result.description,
        tagName: "p"
      })));
    })), hasViewMoreBtn && /*#__PURE__*/_react["default"].createElement("button", {
      onClick: handlePagination,
      className: _siteSearch["default"].viewMoreCta
    }, viewMoreLabel));
  };
  var handlePagination = function handlePagination(e) {
    setResultCount(resultCount + viewmorepagenation);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['container-fluid'] + " " + theme['col-sm-12']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: theme['col-xs-12'] + " " + theme['col-sm-12'] + " " + theme['col-lg-6'] + " " + theme['col-lg-offset-3']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _siteSearch["default"].resultsWrapper
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: _siteSearch["default"].resultsTitle
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: _siteSearch["default"].searchInputWrapper
  }, /*#__PURE__*/_react["default"].createElement("input", {
    ref: inputRef,
    id: "search-term",
    type: "text",
    className: _siteSearch["default"].searchInput,
    placeholder: placeholder,
    onKeyDown: onKeyDown,
    defaultValue: searchTerm,
    key: searchTerm
  }), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return updateSearchTerm(inputRef.current.value);
    },
    className: _siteSearch["default"].searchIcon
  })), searchTerm && !isSearchTermValid && /*#__PURE__*/_react["default"].createElement("div", {
    className: _siteSearch["default"].searchErrorMsg
  }, searchInputWarningMessage), isSearchTermValid && renderSearchResults())))));
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
SiteSearch.resourceType = function () {
  return 'SearchModule_1_0_0';
};
var _default = (0, _reactRedux.connect)(mapStateToProps)(SiteSearch);
exports["default"] = _default;